// Add company_website to User type
export interface User {
  id: string;
  email: string;
  name?: string;
  role: UserRole;
  createdAt: string;
  lastLogin?: string;
  remainingCredits: number;
  subscriptionEnd?: string;
  linkedInId?: string;
  linkedInToken?: string;
  linkedInTokenExpiry?: string;
  password: string;
  subscriptionAmount?: string;
  subscriptionDate?: string;
  nextBillingDate?: string;
  company_website?: string;
}

export type UserRole = 'trial' | 'starter' | 'pro' | 'entreprise' | 'admin' | 'member';

export const USER_LIMITS = {
  trial: {
    credits: 5,
    durationDays: 7,
    features: ['basic_access'],
    prodId: 'prod_trial',
    monthlyPriceId: 'price_trial_monthly',
    yearlyPriceId: 'price_trial_yearly',
    name: 'Trial',
    price: 0
  },
  starter: {
    credits: 50,
    features: ['basic_access', 'job_posts'],
    prodId: 'prod_SJGlgawtwaKGC4',
    monthlyPriceId: 'price_1ROeDxIhYjEmzBERmGmzjoAH',
    yearlyPriceId: 'price_1ROeEXIhYjEmzBERaAw4vTuc',
    name: 'Starter',
    price: 9.99
  },
  pro: {
    credits: 200,
    features: ['basic_access', 'job_posts', 'advanced_analytics'],
    prodId: 'prod_SJGmKldi8gUiqO',
    monthlyPriceId: 'price_1ROeF4IhYjEmzBERiU66Z17K',
    yearlyPriceId: 'price_1ROeFKIhYjEmzBERxpD2kEZw',
    name: 'Pro',
    price: 19.99
  },
  entreprise: {
    credits: 1000,
    features: ['basic_access', 'job_posts', 'advanced_analytics', 'team_access'],
    prodId: 'prod_SJGnwVdIZZm0K6',
    monthlyPriceId: 'price_1ROeFpIhYjEmzBERfsCPw2F8',
    yearlyPriceId: 'price_1ROeG1IhYjEmzBERc5hJUSzs',
    name: 'Enterprise',
    price: 49.99
  },
  admin: {
    credits: Infinity,
    features: ['all'],
    prodId: 'prod_admin',
    monthlyPriceId: 'price_admin_monthly',
    yearlyPriceId: 'price_admin_yearly',
    name: 'Admin',
    price: 0
  },
  member: {
    credits: 0,
    features: ['basic_access'],
    prodId: 'prod_member',
    monthlyPriceId: 'price_member_monthly',
    yearlyPriceId: 'price_member_yearly',
    name: 'Member',
    price: 0
  }
} as const;